import { create } from "zustand";

type ToastVariant = "info" | "success" | "warning" | "error" | "alert";

interface ToastState {
  toastMessage: string;
  toastHeader: string;
  toastVariant: ToastVariant;
  isActionToast: boolean;
  showToast: boolean;
  setToast: (params: {
    message: string;
    header: string;
    variant: ToastVariant;
    isActionToast?: boolean;
  }) => void;
  hideToast: () => void;
}

const useToastStore = create<ToastState>((set) => ({
  toastMessage: "",
  toastHeader: "",
  toastVariant: "info",
  isActionToast: false,
  showToast: false,
  setToast: ({ message, header, variant, isActionToast = true }) =>
    set({
      toastMessage: message,
      toastHeader: header,
      toastVariant: variant,
      isActionToast,
      showToast: true,
    }),
  hideToast: () => set({ showToast: false }),
}));

export { useToastStore };
